/* eslint-disable react-native/no-color-literals */
import React, { useEffect, useRef } from 'react';
import { Text, View, StyleSheet, Image, Pressable } from 'react-native';
import { Modalize } from 'react-native-modalize';
import { useDispatch, useSelector } from 'react-redux';
import { imageCdn } from '~global/helpers';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '~global/screens';

const defaultImage = require('~assets/img/dummy_product.png');
const iconBagSource = require('~assets/img/product/icon-bag-oos.svg');
// eslint-disable-next-line react/display-name
export default () => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();

  const isModalShow = useSelector((state) => state.modal.productOos.isShow);
  const data = useSelector((state) => state.modal.productOos.data);
  const productData = data?.length ? data : [];

  const modalizeRef = useRef(null);

  const openHandler = () => {
    modalizeRef.current?.open();
  };

  const closeHandler = () => {
    modalizeRef.current?.close();
  };

  useEffect(() => {
    isModalShow ? openHandler() : closeHandler();
  }, [isModalShow]);

  const setModalHide = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'productOos', data });
    resetData();
  };

  const resetData = (force) => {
    setTimeout(() => {
      if (force) {
        dispatch({ type: 'MODAL/HIDE', modalName: 'productOos', data });
      }
    }, 400);
  };

  const coverImageSrc = (product) => {
    return product && product.images
      ? product.images.filter((data) => data.is_cover)[0]
      : null;
  };

  const coverImage = (product) => {
    return coverImageSrc(product) && coverImageSrc(product).url
      ? imageCdn({ config: 'w=600', image: coverImageSrc(product).url })
      : null;
  };

  const attributesName = (product) => {
    if (product?.combinations?.length && product.combinations[0].attributes) {
      const combinationAttributes =
        data.attributes ?? product?.combinations[0]?.attributes;
      const name = [];
      for (const i in combinationAttributes) {
        name.push({
          group: i,
          value: combinationAttributes[i].name,
        });
      }
      return name;
    } else {
      return '';
    }
  };

  if (!productData?.length) {
    return <></>;
  }

  const ProductItem = (productProps) => {
    const { product = {} } = productProps;
    return (
      <View style={styles.modalProductSummary}>
        <Image
          source={{ uri: coverImage(product) ? coverImage(product) : null }}
          style={styles.modalProductImage}
          resizeMode="cover"
          defaultSource={defaultImage}
        />
        <View style={styles.modalProductInfo}>
          <Text
            style={styles.modalProductBrand}
            numberOfLines={1}
            ellipsizeMode="tail">
            {product.brand.name}
          </Text>
          <Text
            style={styles.modalProductName}
            numberOfLines={1}
            ellipsizeMode="tail">
            {product.name}
          </Text>
          <Text style={styles.modalProductCombination}>
            {attributesName(product) &&
              attributesName(product).map((res, index) => (
                <Text key={index}>
                  <Text style={styles.modalProductCombinationGroup}>
                    {index > 0 ? ', ' : ''}
                    {res.group}:&nbsp;
                  </Text>
                  <Text style={styles.modalProductCombinationValue}>
                    {res.value}
                  </Text>
                </Text>
              ))}
          </Text>
        </View>
      </View>
    );
  };

  return (
    <Modalize
      ref={modalizeRef}
      adjustToContentHeight={true}
      handleStyle={styles.handleStyle}
      modalStyle={styles.modalStyle}
      onClose={() => resetData(true)}>
      <View style={{ paddingBottom: insets.bottom }}>
        <View style={styles.modalProductSuccess}>
          <Image
            source={iconBagSource}
            style={styles.modalProductIconBag}
            resizeMode="cover"
            width={46}
            height={50}
          />
          <Text style={styles.modalProductOos}>
            Oops, bundle cannot be added to your bag
          </Text>
          {isWeb ? (
            <Pressable
              style={styles.modalProductClose}
              onPress={() => setModalHide()}>
              <WithLocalSvg
                width={14}
                height={14}
                asset={require('~assets/img/product/icon-close.svg')}
              />
            </Pressable>
          ) : (
            false
          )}
        </View>
        <Text style={styles.modalCopywriting}>
          Maaf, ada product yang saat ini out of stock:
        </Text>
        <View style={styles.modalProductWrapper}>
          {productData.map((item, idx) => (
            <ProductItem product={item} key={idx} />
          ))}
        </View>
      </View>
    </Modalize>
  );
};

const styles = StyleSheet.create({
  modalProductWrapper: {
    paddingHorizontal: 16,
    paddingTop: 10,
  },
  modalProductSummary: {
    flexDirection: 'row',
    marginBottom: 15,
  },
  modalProductSuccess: {
    backgroundColor: '#F3F0FC',
    paddingHorizontal: 28,
    paddingVertical: 22,
    flexDirection: 'row',
    alignItems: 'center',
  },
  modalProductImage: {
    width: 64,
    height: 64,
    marginRight: 12,
    borderRadius: 8,
    overflow: 'hidden',
  },
  modalProductIconBag: {
    marginRight: 15,
    width: 46,
    height: 50,
  },
  modalCopywriting: {
    fontSize: 13,
    lineHeight: 16,
    fontFamily: 'satoshi-medium',
    marginBottom: 10,
    paddingHorizontal: 20,
    paddingTop: 15,
  },
  modalProductInfo: {
    paddingTop: 4,
    paddingRight: 16,
    flex: 1,
  },
  modalProductBrand: {
    fontSize: 10,
    lineHeight: 13,
    fontFamily: 'satoshi-black',
    letterSpacing: 0.91,
    color: '#A775C8',
    marginBottom: 3,
    textTransform: 'uppercase',
  },
  modalProductName: {
    fontSize: 13,
    lineHeight: 16,
    fontFamily: 'satoshi-medium',
    marginBottom: 6,
    color: '#25182E',
  },
  modalProductCombination: {
    fontSize: 11,
    lineHeight: 15,
    fontFamily: 'satoshi-black',
    color: '#685C6D',
  },
  modalProductCombinationValue: {
    fontFamily: 'satoshi-medium',
  },
  modalProductCombinationGroup: {
    textTransform: 'capitalize',
  },
  handleStyle: {
    top: 26,
    backgroundColor: isWeb ? 'transparent' : '#D7CDF5',
    height: 3,
    width: 38,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    overflow: 'hidden',
    ...(isWeb
      ? {
          width: 400,
          margin: 'auto',
          borderRadius: 8,
        }
      : {}),
  },
  modalProductOos: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: 'poppins-medium',
    color: '#2B0446',
    maxWidth: '70%',
  },
  modalProductClose: {
    position: 'absolute',
    right: 15,
    top: 20,
  },
});
